import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import {Navigation, Pagination} from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    initializeSliders()

    initializeSeparateImages()











    function initializeSliders() {
        const mainSlider = new Swiper('.main-slider', {
            modules: [Navigation],
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: {
                // nextEl: '.separate-car-button-next',
                // prevEl: '.separate-car-button-prev',
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumbSlider,
            },
        });

        const thumbSlider = new Swiper('.thumb-slider', {
            spaceBetween: 16,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slideToClickedSlide: true,
            centeredSlides: false,
        });



        if(mainSlider) {
            mainSlider.on("slideChange", function () {
                let activeIndex = mainSlider.activeIndex;
                thumbSlider.slideTo(activeIndex - 1); // lagano pomeranje, uvek drži u fokusu
            });


            thumbSlider.slides.forEach((slide, index) => {
                slide.addEventListener('click', () => {
                    mainSlider.slideTo(index);  // menja glavnu sliku
                });
            });

            // Sinkronizacija aktivne thumbnail klase
            mainSlider.on('slideChange', () => {
                thumbSlider.slides.forEach(slide => slide.classList.remove('swiper-slide-thumb-active'));
                thumbSlider.slides[mainSlider.activeIndex].classList.add('swiper-slide-thumb-active');
            });

            // Postavi prvu thumbnail kao aktivnu
            if (thumbSlider && thumbSlider.slides && thumbSlider.slides.length > 0 && thumbSlider.slides[0]) {
                thumbSlider.slides[0].classList.add('swiper-slide-thumb-active');
            }
        }
    }




    function initializeSeparateImages() {

        const sliderDiv = document.querySelector('.separate-car--basic-info__main-gallery');
        if (sliderDiv) {
            const sliders =  sliderDiv.querySelectorAll('.main-slider__img');
            sliders.forEach((image) => {
                image.classList.add('loaded');
            })
            // sliderDiv.querySelectorAll('.swiper-about-us-gallery__img').forEach((swiperImages) => {
            //     swiperImages.forEach((image) => {
            //         image.classList.add('loaded');
            //     });
            // });
        }
    }



    // const thumbSlider = new Swiper('.thumb-slider', {
    //     spaceBetween: 16,
    //     slidesPerView: 4,
    //     freeMode: true,
    //     watchSlidesProgress: true,
    //     watchSlidesVisibility: true,
    //     slideToClickedSlide: true,
    //     centeredSlides: false,
    // });

// Glavni slider
//     const mainSlider = new Swiper('.main-slider', {
//         modules: [Navigation],
//         spaceBetween: 10,
//         slidesPerView: 1,
//         navigation: {
//             // nextEl: '.separate-car-button-next',
//             // prevEl: '.separate-car-button-prev',
//             nextEl: ".swiper-button-next",
//             prevEl: ".swiper-button-prev",
//         },
//         thumbs: {
//             swiper: thumbSlider,
//         },
//     });

    // if(mainSlider) {
    //     mainSlider.on("slideChange", function () {
    //         let activeIndex = mainSlider.activeIndex;
    //         thumbSlider.slideTo(activeIndex - 1); // lagano pomeranje, uvek drži u fokusu
    //     });
    //
    //
    //     thumbSlider.slides.forEach((slide, index) => {
    //         slide.addEventListener('click', () => {
    //             mainSlider.slideTo(index);  // menja glavnu sliku
    //         });
    //     });
    //
    // // Sinkronizacija aktivne thumbnail klase
    //     mainSlider.on('slideChange', () => {
    //         thumbSlider.slides.forEach(slide => slide.classList.remove('swiper-slide-thumb-active'));
    //         thumbSlider.slides[mainSlider.activeIndex].classList.add('swiper-slide-thumb-active');
    //     });
    //
    // // Postavi prvu thumbnail kao aktivnu
    //     if (thumbSlider && thumbSlider.slides && thumbSlider.slides.length > 0 && thumbSlider.slides[0]) {
    //         thumbSlider.slides[0].classList.add('swiper-slide-thumb-active');
    //     }
    // }
});
